import { Box, Icons, Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../../Dropdown';
import { SSNCaption } from '../SSNCaption';
import { PrivateSSNCompletedResult } from './PrivateSSNCompletedResult';
import { PrivateSSNRequestDataTable } from './PrivateSSNRequestDataTable';
import { JobType } from 'components/account/jobs/job_type';
import { useGlobalState } from 'store/reducers/reducer';
import { getPrivateSSNJob } from 'store/sagas/sagas';
export const PrivateSSNDropdowns = ({ jobSid, parentJobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [privateSSNJob, setPrivateSSNJob] = useState(null);
    useEffect(() => {
        asyncDispatch(getPrivateSSNJob(jobSid)).then(setPrivateSSNJob, console.error);
    }, [jobSid]);
    if (!privateSSNJob)
        return (React.createElement(Dropdown, { title: "SSN" },
            React.createElement(Box, null,
                React.createElement(SSNCaption, { type: JobType.privateSSN }),
                React.createElement(Icons.Loading, null))));
    const { request_data, response_data, status, dob_strict_match } = privateSSNJob;
    const ssnIsMatch = response_data?.identifiers?.ssn ??
        response_data?.identifiers?.last4 ??
        response_data?.verified;
    const dobIsMatch = dob_strict_match
        ? response_data?.identifiers?.dob
        : undefined;
    if (ssnIsMatch === undefined) {
        return (React.createElement(Dropdown, { title: "SSN" },
            React.createElement(Box, null,
                React.createElement(SSNCaption, { type: JobType.privateSSN }),
                React.createElement(Text, null, "SSN verification could not be completed. Please try again or contact support."),
                React.createElement(Box, { display: "flex", marginTop: "spacing.default", style: { gap: '15px' } },
                    React.createElement(Text, null, "Source:"),
                    React.createElement(Text, { style: { fontWeight: '600' } }, "Private")),
                request_data && (React.createElement(PrivateSSNRequestDataTable, { requestData: request_data })))));
    }
    return (React.createElement(PrivateSSNCompletedResult, { dobIsMatch: dobIsMatch, jobStatus: status, parentJobStatus: parentJobStatus, requestData: request_data, ssnIsMatch: ssnIsMatch }));
};
